// src/components/Login.jsx
import React, { useState, useEffect } from 'react';
import '../styles/Login.css';
import aioticslogo from '../assets/aiotics.png';
import axios from 'axios';

const Login = ({ setPage, user, setUser }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [animateBg, setAnimateBg] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser && !user) setUser(JSON.parse(savedUser));
  }, [setUser, user]);


  // Attach token if it exists
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const res = await axios.post('/api/login', { username, password });
      const data = res.data;

      if (res.status === 200) {
        const newUser = { username: data.username, role: data.role, token: data.token };
        setUser(newUser);
        localStorage.setItem('user', JSON.stringify(newUser));
        localStorage.setItem('token', data.token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;

        const roleRedirectMap = {
          admin: "home",
          operator: "home",
          operator_Pharma: "home",
          operator_Mfg: "manufacturing",
          operator_Powerplant: "powerplant",
          viewuser: "powerplant",
        };
        setPage(roleRedirectMap[data.role] || 'home');
      } else {
        setMessage(`❌ ${data.message}`);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data?.error === "already_logged_in") {
          setMessage("⚠️ This user is already logged in from another session.");
        } else if (err.response.status === 401) {
          setMessage("❌ Invalid username or password.");
        } else {
          setMessage(`⚠️ ${err.response.data?.message || "Login failed."}`);
        }
      } else {
        setMessage("🚨 Cannot reach server. Try again later.");
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    sessionStorage.clear();
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setPage('login');
  };

  if (user) {
    return (
      <div className="login-wrapper">
        <h2>👋 Welcome back, {user.username}</h2>
        <p>Your role: {user.role}</p>
        <button onClick={handleLogout}>Logout</button>
        <img src={aioticslogo} alt="Aiotics Logo" className="bottom-logo" />
      </div>
    );
  }

  return (
    <div className={`login-wrapper ${animateBg ? 'bg-animate' : ''}`}>
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Login</h2>
        <div className="form-group">
          <label>Username</label>
          <input value={username} onChange={e => setUsername(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        </div>
        <button type="submit">Sign In</button>
        {message && <p className="login-message">{message}</p>}
      </form>
      <img src={aioticslogo} alt="Aiotics Logo" className="bottom-logo" />
    </div>
  );
};

export default Login;
